export default __webpack_public_path__ + "static/media/pic4.f7e94e1e.png";